import StorefrontFilters from '@local-types/filters/storefrontFilters'
import { ActiveFilters } from 'reducers/filtersReducer'
import { getAllergenIdFromSlug, getAllergenSlugFromId } from './allergenUrlHelper'
import { getCategoryIdFromSlug, getCategorySlugFromId } from './categoryUrlHelper'
import { getTreeFilterIdFromSlug, getTreeFilterSlugFromId } from './treeFilterUrlHelper'

export interface ReadableFilters {
	flokkar: string[]
	sermerkingar: string[]
	ofnaemi: string[]
	leit: string
	rod: string
}

export const readableFiltersFromActiveFilters = (
	activeFilters: ActiveFilters,
	filters: StorefrontFilters | null
): ReadableFilters => {
	if (!filters) {
		return {
			flokkar: activeFilters.catTreePath,
			sermerkingar: activeFilters.catTreeFilterIds,
			ofnaemi: activeFilters.allergenFilterIds,
			leit: activeFilters.search,
			rod: activeFilters.sort,
		}
	}
	// get slugs
	const categoriesSlugs: string[] = activeFilters.catTreePath
		.map(x => getCategorySlugFromId(x, filters.mainCategoryTree))
		.map(x => encodeURI(x))
	const treeFilterSlugs: string[] = activeFilters.catTreeFilterIds
		.map(x => getTreeFilterSlugFromId(x, filters.categoryFilterTrees))
		.map(x => encodeURI(x))
	// get allergens mapped
	const mappedAllergens: string[] = activeFilters.allergenFilterIds
		.map(x => getAllergenSlugFromId(x))
		.map(x => encodeURI(x))

	return {
		flokkar: categoriesSlugs,
		sermerkingar: treeFilterSlugs,
		ofnaemi: mappedAllergens,
		leit: activeFilters.search,
		rod: activeFilters.sort,
	}
}

export const activeFiltersFromReadableUrlParams = (
	urlParams: URLSearchParams,
	delimiter: string,
	allFilters: StorefrontFilters | null
) => {
	return {
		allergenFilterIds:
			urlParams
				.get('ofnaemi')
				?.split(delimiter)
				.filter(x => x !== '')
				.map(x => decodeURI(x))
				.map(x => getAllergenIdFromSlug(x)) || [],
		catTreeFilterIds:
			urlParams
				.get('sermerkingar')
				?.split(delimiter)
				.filter(x => x !== '')
				.map(x => decodeURI(x))
				.map(x => getTreeFilterIdFromSlug(x, allFilters?.categoryFilterTrees || [])) || [],
		catTreePath:
			urlParams
				.get('flokkar') // flokkar
				?.split(delimiter)
				.filter(x => x !== '')
				.map(x => decodeURI(x))
				.map(x => getCategoryIdFromSlug(x, allFilters?.mainCategoryTree || null)) || [],
		search: urlParams.get('leit') || '',
		sort: urlParams.get('rod') || '',
	}
}
